import type { SemanticSet } from "./tokens";

type Override = { [K in keyof SemanticSet]?: Partial<SemanticSet[K]> };

/**
 * Ajustes propios de este sistema, por modo.
 *
 * LÍMITES — leer antes de escribir acá:
 *
 * - Esto es la ESCAPATORIA, no la vía principal. La apariencia se declara en el
 *   bloque `theme` de la configuración del proyecto, que alcanza también a los
 *   correos y a la portada. Lo que se escriba acá vale SOLO para la aplicación
 *   web, así que un color puesto acá y no allá produce un correo que no combina.
 *
 * - Va lo que la configuración no pueda expresar. Si algo se puede decir con un
 *   token, decirlo con el token: lo de acá no pasa por la comprobación de
 *   contraste al generar.
 *
 * - Se fusiona por superficie: alcanza con nombrar lo que cambia. Cambiar un
 *   fondo no obliga a repetir el color del texto que va encima.
 *
 * Vacío significa que este sistema usa el tema tal como viene.
 */
export const identity: { light?: Override; dark?: Override } = {};
